<template>
  <div class="container">
    <div class="block">
      <div class="block-title flex">
        <div class="select-wrap">
          <span class="select-title">统计年份：</span>
          <el-select
            placeholder="请选择"
            v-model="searchInfo.year"
            @change="handleYearChange"
          >
            <el-option
              v-for="item in yearList"
              :label="item.label + '年'"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </div>

        <div class="export">
          <el-button
            class="mwow-button-filled primary export-btn"
            @click="handleExport"
          >
            导出
          </el-button>
        </div>
      </div>
      <div class="total-wrap flex">
        <div class="item flex" v-for="item in topData" :key="item.title">
          <div class="title-wrap flex">
            <div class="title-text">{{ item.title }}</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">
                {{
                  item.tips.length === 12
                    ? "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + item.tips
                    : item.tips
                }}
              </p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
          <div v-show="item.show === '1'">
            <p class="number">
              {{ item.value }}
            </p>
          </div>
        </div>
      </div>
      <div class="table-wrap">
        <el-table
          :data="tableData"
          v-horizontal-scroll
          stripe
          style="width: 100%"
          ref="elTableRef"
          key="elTableRef"
        >
          <el-table-column
            :label="calculateYear + '年'"
            prop="title"
            fixed="left"
            width="150"
          >
            <template slot-scope="scope">
              <div class="flex">
                <div>{{ scope.row.title }}</div>
                <div>
                  <el-popover
                    placement="top"
                    width="190"
                    popper-class="followuppopover"
                    trigger="hover"
                  >
                    <p class="tipck">
                      {{ scope.row.tips }}
                    </p>
                    <div class="question" slot="reference">
                      <div>?</div>
                    </div>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="1月" prop="january">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 1).january }}
            </template>
          </el-table-column>
          <el-table-column label="2月" prop="february">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 2).february }}
            </template>
          </el-table-column>
          <el-table-column label="3月" prop="march">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 3).march }}
            </template>
          </el-table-column>
          <el-table-column label="4月" prop="april">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 4).april }}
            </template>
          </el-table-column>
          <el-table-column label="5月" prop="may">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 5).may }}
            </template>
          </el-table-column>
          <el-table-column label="6月" prop="june">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 6).june }}
            </template>
          </el-table-column>
          <el-table-column label="7月" prop="july">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 7).july }}
            </template>
          </el-table-column>
          <el-table-column label="8月" prop="august">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 8).august }}
            </template>
          </el-table-column>
          <el-table-column label="9月" prop="september">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 9).september }}
            </template>
          </el-table-column>
          <el-table-column label="10月" prop="october">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 10).october }}
            </template>
          </el-table-column>
          <el-table-column label="11月" prop="november">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 11).november }}
            </template>
          </el-table-column>
          <el-table-column label="12月" prop="december">
            <template slot-scope="scope">
              {{ handleIsShow(scope.row, 12).december }}
            </template>
          </el-table-column>
          <el-table-column label="本年(合计)" prop="total" fixed="right">
            <template slot-scope="scope">
              {{
                handleTotal(scope.row).total === ""
                  ? "-"
                  : handleTotal(scope.row).total
              }}
            </template>
          </el-table-column>
        </el-table>
        <div class="bottom-tips">
          学员数是按照人数统计（不是按人次数统计），本年合计会过滤重复人数
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import json2csv from "json2csv";
import { renewDataListApi } from "@/api/statistics";

export default {
  data() {
    return {
      topData: [
        {
          key: "rate_of_renew",
          title: "本月续费率",
          value: "",
          tips: "本月续费率=本月续费学员数/本月月初在读学员数*100%",
          show: "1",
          noClick: false,
        },
        {
          key: "course_renew_count",
          title: "年初学员续费率",
          value: "",
          tips: "年初学员续费率=年初学员续费合计数/年初在读学员数*100%",
          show: "1",
          noClick: true,
        },
        {
          key: "course_renew_count",
          title: "本年新增学员续费率",
          value: "",
          tips: "本年新增学员续费率=本年新签学员的续费数/本年新增学员数*100%",
          show: "1",
          noClick: true,
        },
        {
          key: "course_renew_count",
          title: "本年续费率",
          value: "",
          tips: "本年续费率=本年续费学员数/（本年新增学员数+年初在读学员数）*100%",
          show: "1",
          noClick: true,
        },
      ],
      tableData: [
        // {
        //   title: "月初在读学员数",
        //   tips: "当月1月1号00:00的在读学员数",
        //   january: "1",
        //   february: "2",
        //   march: "3",
        //   april: "4",
        //   may: "5",
        //   june: "6",
        //   july: "7",
        //   august: "8",
        //   september: "9",
        //   october: "10",
        //   november: "11",
        //   december: "12",
        //   total: "50",
        // },
      ],
      tableDataTips: [
        "当月1号00:00的在读学员数",
        "当月新增新签的学员数",
        "年初在读学员中，在当月续费的学员数",
        "本年新签学员中，在当月续费的学员人数", // "学员人数"，只针对当前字段的提示
        "年初历史学员进行续费的学员数",
        "当月续费学员数，续费学员数=年初学员续费数+本年新签学员续费数+年初历史学员续费数",
        "当月续费率=当月续费学员数/当月月初在读学员数*100%",
      ],
      exportTableData: [], // 需要导出的数据
      searchInfo: {
        year: "",
      },
      // 从最早的年份数据到今年
      yearList: [],
      exporting: false,
      curYear: "", // 当前年份
      curMonth: "", // 当前月份
    };
  },
  computed: {
    calculateYear() {
      let text;
      this.yearList.forEach((item) => {
        if (item.value === this.searchInfo.year) {
          text = item.label;
        }
      });
      return text || this.curYear;
    },
  },
  created() {
    this.curMonth = new Date().getMonth() + 1;
    this.curYear = new Date().getFullYear();
    for (let i = this.curYear; i >= 2017; i--) {
      this.yearList.push({
        value: `${String(i)}`,
        label: `${String(i)}`,
      });
    }
    this.searchInfo.year = String(this.curYear);
    this.getRenewDataList("");
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getRenewDataList(val) {
      renewDataListApi({
        year: val || Number(this.calculateYear),
      }).then((res) => {
        Object.values(res.data.top).forEach((item, index) => {
          this.topData[index].value = item + "%";
        });
        this.tableData = res.data.list.map((item, index) => {
          item.tips = this.tableDataTips[index]; // 添加提示
          item.setId = index + 1; // 自定义 id
          if (item.title === "续费率") {
            for (let it in item) {
              // 不给 title 加 %，手动为 total 加 %
              if (it === "title" || it === "total" || it === "tips") {
                continue;
              }
              item[it] = item[it] + "%";
            }
          }
          return item;
        });
        this.exportTableData = [
          ...this.tableData,
          {
            title: `本月续费率:${this.topData[0].value}`,
          },
          {
            title: `年初学员续费率:${this.topData[1].value}`,
          },
          {
            title: `本年新增学员续费率:${this.topData[2].value}`,
          },
          {
            title: `本年续费率:${this.topData[3].value}`,
          },
        ];
        //  $nextTick 为当前月份的添加高亮背景
        this.$nextTick(() => {
          // 获取 el-table dom 元素
          const elTableRef = this.$refs["elTableRef"];

          // 获取 tbody 下所有的 head，表头 (与 el-table__body-wrapper 类名对应，控制台的类名获取不到)
          const allTh = elTableRef.$el
            .querySelector(".el-table__header-wrapper")
            .querySelectorAll("table tr");
          //  遍历列表，获取每行 th 下所有的 tr
          allTh.forEach((item) => {
            let allTr = item.children;
            //   $nextTick 为当前月份的 th 添加高亮背景
            this.$nextTick(() => {
              allTr.forEach((it, index) => {
                if (Number(this.curYear) === Number(this.calculateYear)) {
                  if (index === this.curMonth) {
                    it.style.backgroundColor = "rgba(228,248,223)";
                  }
                } else {
                  it.style.backgroundColor = "";
                }
              });
            });
          });

          // 获取 tbody 下所有的 body，表体
          const allTr = elTableRef.$el
            .querySelector(".el-table__body-wrapper")
            .querySelectorAll("tbody tr");
          // 遍历列表，获取每行 tr 下所有的 td
          allTr.forEach((item) => {
            let allTd = item.children;
            //  借助 $nextTick 为当前月份的 td 添加高亮背景
            this.$nextTick(() => {
              allTd.forEach((it, index) => {
                if (Number(this.curYear) === Number(this.calculateYear)) {
                  if (index === this.curMonth) {
                    it.style.backgroundColor = "rgba(228,248,223)";
                  }
                } else {
                  it.style.backgroundColor = "";
                }
              });
            });
          });
        });
      });
    },
    handleYearChange() {
      this.getRenewDataList(this.searchInfo.year);
    },
    // 如果不是今年，展示所有数据；如果是今年，只展示比当前月份少的数据
    handleIsShow(row, month) {
      let data;
      if (Number(this.curYear) === Number(this.calculateYear)) {
        if (this.curMonth >= month) {
          data = row;
        } else {
          data = "";
        }
      } else {
        data = row;
      }
      return data;
    },
    handleTotal(row) {
      let data = row;
      // 月初在读学员数 和 续费率 直接展示 "-"
      if (data.setId === 1) {
        data.total = "";
      }
      return data;
    },
    handleResize() {
      this.$nextTick(() => {
        this.$refs.elTableRef.doLayout();
      });
    },
    handleExport() {
      if (this.exporting) {
        return false;
      }
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.exporting = true;
      this.exportTableData = this.exportTableData.map((item) => {
        delete item["tips"];
        delete item["setId"];
        item[`${this.curYear}年`] = item.title;
        delete item["title"];
        item["1月"] = this.handleIsShow(item, 1).january;
        delete item["january"];

        item["2月"] = this.handleIsShow(item, 2).february;
        delete item["february"];

        item["3月"] = this.handleIsShow(item, 3).march;
        delete item["march"];

        item["4月"] = this.handleIsShow(item, 4).april;
        delete item["april"];

        item["5月"] = this.handleIsShow(item, 5).may;
        delete item["may"];

        item["6月"] = this.handleIsShow(item, 6).june;
        delete item["june"];

        item["7月"] = this.handleIsShow(item, 7).july;
        delete item["july"];

        item["8月"] = this.handleIsShow(item, 8).august;
        delete item["august"];

        item["9月"] = this.handleIsShow(item, 9).september;
        delete item["september"];

        item["10月"] = this.handleIsShow(item, 10).october;
        delete item["october"];

        item["11月"] = this.handleIsShow(item, 11).november;
        delete item["november"];

        item["12月"] = this.handleIsShow(item, 12).december;
        delete item["december"];

        item["本年(合计)"] = this.handleTotal(item).total;
        delete item["total"];
        return item;
      });

      try {
        const result = json2csv.parse(this.exportTableData);
        //非IE浏览器
        const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
        //使用a标签的download属性实现下载功能
        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = `${this.searchInfo.year}${userInfo.org_name}续费数据.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message({
          type: "success",
          message: "导出成功",
        });
        // 5秒导出间隔
        setTimeout(() => {
          this.exporting = false;
        }, 5000);
        // createOperationLogApi({
        //   code: 10505,
        //   detail: "导出门店综合数据",
        // });
      } catch (err) {
        this.$message({
          type: "error",
          message: err.toString(),
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.block {
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
  padding: 15px 12px;
  overflow-x: hidden;
  .block-title {
    .select-title {
      font-size: 12px;
      color: #5c5d5e;
    }
    /deep/.select-wrap {
      .el-input__inner {
        height: 30px !important;
      }
      .el-input__icon {
        line-height: 30px !important;
      }
      .el-input__inner:focus {
        border-color: #07d1aa !important;
      }
    }
    .export {
      .export-btn {
        margin-left: 20px;
      }
    }
  }

  .total-wrap {
    margin: 16px 0;
    width: 70%;
    .item {
      flex: 1.5;
      padding: 10px 0;
      border-right: 1px solid #f1f2f2;
      flex-direction: column;
      background: #f6fafc;
      color: #5c5d5e;
      .title-wrap {
        font-size: 12px;
        line-height: 28px;
        display: flex;
        align-items: center;
        .title-text {
          font-size: 14px;
        }
      }
      .number {
        font-size: 20px;
        font-weight: bold;
        line-height: 42px;
      }
    }
    .item:nth-child(4) {
      border: none;
    }
  }
  .table-wrap {
    .bottom-tips {
      margin-top: 15px;
      padding: 0 0 0 5px;
      font-size: 12px;
      color: #f49595;
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
